import { render, staticRenderFns } from "./MerageMember.component.vue?vue&type=template&id=6503e557&scoped=true"
import script from "./MerageMember.component.vue?vue&type=script&lang=js"
export * from "./MerageMember.component.vue?vue&type=script&lang=js"
import style0 from "./MerageMember.component.vue?vue&type=style&index=0&id=6503e557&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6503e557",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCard,VCol,VRadio,VRow,VTextField})
